<template>
  <card id="multicastGroupEndDevices" :title="$t('mcg-endDevices:endDevices')" no-body no-footer>
    <div slot="card-header-right" class="d-flex">
      <input id="filterEndDevices" v-model="filterEndDevices" :placeholder="$t('mcg-endDevices:filter') | capitalize" type="text" class="form-control form-control-sm mr-2">
    </div>

    <div slot="card-table" class="end-devices-list">
      <div v-if="filteredEndDevices.length===0" class="text-center text-muted font-italic my-3">
        {{ $t('mcg-endDevices:noEndDevices') | capitalize }}
      </div>

      <ul class="list-group list-group-flush">
        <router-link v-for="endDevice in filteredEndDevices" :key="endDevice" :to="{name: 'endDevice', params: {devEui: endDevice}}" class="list-group-item">{{ endDevice }}</router-link>
      </ul>
    </div>
  </card>
</template>

<script>
import { orderBy, filter } from 'lodash-es'

export default {
  props: {
    multicastGroup: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      filterEndDevices: ''
    }
  },

  computed: {
    // Filter end-devices
    filteredEndDevices () {
      return orderBy(filter(this.multicastGroup.endDevices, ed => ed.toLowerCase().indexOf(this.filterEndDevices.toLowerCase()) > -1))
    }
  }
}
</script>

<style scoped lang="scss">
  .end-devices-list {
    max-height: 50vh;
    overflow-y: auto;
  }
</style>
